const sizeOptionFilterTitle = document.querySelector("li.Talla");
const sizeOptionFilterList = document.querySelectorAll("li[data-key-rel='talla']");
const mqTablet = window.matchMedia("all and (max-width: 750px)");

if (
    sizeOptionFilterList.length > 0 &&
    sizeOptionFilterTitle !== null &&
    mqTablet.matches
) {
    const sizeOptionsContainer = document.createElement("div");
    sizeOptionsContainer.classList.add("size-options-container");
    sizeOptionFilterTitle.after(sizeOptionsContainer);

    sizeOptionFilterList.forEach(sizeOptionFilter => {
        sizeOptionsContainer.appendChild(sizeOptionFilter);
    });
}
